(function () {
  function qsa(root, sel) {
    try { return Array.prototype.slice.call(root.querySelectorAll(sel)); } catch (e) { return []; }
  }

  function firstMatch(selectors) {
    var list = String(selectors || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    for (var i = 0; i < list.length; i++) {
      var el = document.querySelector(list[i]);
      if (el) return el;
    }
    return null;
  }

  function visibleStickyHeight(root) {
    var panel = root.querySelector('.satc__panel.is-visible');
    if (!panel) return 0;
    return panel.getBoundingClientRect().height || panel.offsetHeight || 0;
  }

  function readInt(root, attr, fallback) {
    var n = parseInt(root.getAttribute(attr) || String(fallback), 10);
    return isNaN(n) ? fallback : n;
  }

  function findMainAtc(root) {
    var custom = root.getAttribute('data-scroll-selector');
    var el = firstMatch(custom);
    if (el && el.hasAttribute('data-pir-atc-anchor')) return el;
    el = document.querySelector('[data-pir-atc-anchor]');
    if (el) return el;
    el = document.querySelector('.pir-buy .pir-atc, .pir-buybox .pir-atc');
    if (el) return el;
    return firstMatch(custom);
  }

  function applyBodyPad(root, on) {
    if (!on) {
      document.documentElement.style.removeProperty('--satc-body-pad');
      document.body.classList.remove('satc-has-sticky');
      return;
    }
    window.requestAnimationFrame(function () {
      var panel = root.querySelector('.satc__panel.is-visible');
      var h = panel ? (panel.getBoundingClientRect().height || panel.offsetHeight || 0) : 0;
      if (h < 1) h = 96;
      document.documentElement.style.setProperty('--satc-body-pad', Math.ceil(h) + 'px');
      document.body.classList.add('satc-has-sticky');
    });
  }

  function scrollToMainAtc(root) {
    var el = findMainAtc(root);
    if (!el) return false;

    var align = root.getAttribute('data-scroll-align') || 'bottom';
    var gap = readInt(root, 'data-scroll-offset', 8);
    var moreAbove = readInt(root, 'data-scroll-extra-up', 120);
    var rect = el.getBoundingClientRect();
    var y;

    if (align === 'top') {
      y = window.pageYOffset + rect.top - gap;
    } else {
      var stickyH = visibleStickyHeight(root);
      var fromBottom = stickyH + gap - moreAbove;
      if (fromBottom < 0) fromBottom = 0;
      y = window.pageYOffset + rect.bottom - window.innerHeight + fromBottom;
    }

    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });

    el.classList.add('satc-scroll-target');
    try { el.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
    window.setTimeout(function () {
      el.classList.remove('satc-scroll-target');
    }, 1600);

    return true;
  }

  function init(root) {
    if (!root || root.getAttribute('data-satc-ready')) return;
    root.setAttribute('data-satc-ready', 'true');

    var panels = qsa(root, '[data-satc-panel]');
    if (!panels.length) return;

    var showWhenOut = root.getAttribute('data-show-when-out-of-view') !== 'false';
    var hideNearFooter = root.getAttribute('data-hide-near-footer') === 'true';
    var observeMode = root.getAttribute('data-observe-mode') || 'product_info';

    function findProductInfoSection() {
      var inner = document.querySelector('[data-piv1], [data-product-info-raf], [data-satc-observe]');
      if (!inner) return null;
      return inner.closest('.shopify-section') || inner;
    }

    var productInView = showWhenOut;
    var footerInView = false;

    function syncVisibility() {
      var show;
      if (showWhenOut) {
        show = !productInView && !(hideNearFooter && footerInView);
      } else {
        show = !(hideNearFooter && footerInView);
      }
      panels.forEach(function (panel) {
        panel.classList.toggle('is-visible', !!show);
      });
      applyBodyPad(root, show);
    }

    qsa(root, '[data-satc-btn]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var clickScrolls = root.getAttribute('data-click-scrolls-to-atc') !== 'false';
        if (!clickScrolls && !btn.hasAttribute('data-satc-scroll')) return;
        e.preventDefault();
        scrollToMainAtc(root);
      });
    });

    if (!('IntersectionObserver' in window)) {
      productInView = false;
      footerInView = false;
      syncVisibility();
      return;
    }

    var productTarget = observeMode === 'atc_button'
      ? (document.querySelector('[data-pir-atc-anchor]') || firstMatch(root.getAttribute('data-scroll-selector')))
      : findProductInfoSection();
    if (showWhenOut && productTarget) {
      var productObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            productInView = entry.isIntersecting;
            syncVisibility();
          });
        },
        {
          root: null,
          rootMargin: '0px 0px -8% 0px',
          threshold: 0
        }
      );
      productObserver.observe(productTarget);
    } else if (showWhenOut && !productTarget) {
      productInView = false;
    } else {
      productInView = false;
    }

    if (hideNearFooter) {
      var footerTarget = firstMatch(
        'footer.site-footer, .site-footer, #shopify-section-footer, .shopify-section-group-footer-group, [id*="footer-group"]'
      );
      if (footerTarget) {
        var footerObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              footerInView = entry.isIntersecting;
              syncVisibility();
            });
          },
          {
            root: null,
            // Hide as soon as footer approaches the sticky bar area
            rootMargin: '0px 0px -12% 0px',
            threshold: 0
          }
        );
        footerObserver.observe(footerTarget);
      }
    }

    syncVisibility();
  }

  function boot() {
    qsa(document, '[data-sticky-atc-raf]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e || !e.target) return;
    qsa(e.target, '[data-sticky-atc-raf]').forEach(function (el) {
      el.removeAttribute('data-satc-ready');
      init(el);
    });
  });
})();
